module.exports = __webpack_public_path__ + "img/00016.4dcecdc6.webp";